import React, { useEffect, useState } from "react";
import classes from "./Messages.module.css";

import ChatScreen from "./chat/chat";

import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import MessagesMobile from "./MessagesMobile";
import Layout from "../Layout/Layout";

const MessagesDesktop = () => {
  const [location1, setLocation1] = useState();

  return (
    <div className={classes.AdminTableMain}>
      <div className={[classes.StudentDetailsScreen].join(" ")}>
        {/* Layout */}
        <Layout location1={location1} />

        <ChatScreen />
      </div>
    </div>
  );
};

const Messages = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <MessagesMobile /> : <MessagesDesktop />;
};

export default Messages;
